import { requestJson } from './requestJson';

export async function getMyTests(): Promise<{
  creator: { email: string; display_name: string | null; avatar_url: string | null };
  tests: {
    test_id: string;
    dashboard_key: string;
    youtube_id: string;
    title: string | null;
    created_at: string;
    reviewer_count: number;
    finished_count: number;
    reaction_count: number;
  }[];
}> {
  return await requestJson('/api/my/tests');
}
